(function () {
    'use strict';

    angular.module('app.charts')
        .directive('barChart', barChart);

    /* @ngInject */
    function barChart(SETTINGS, DataFactory, $rootScope) {
        return {
            restrict: 'E',
            template: '<div class="chart-header"><div ng-if="logoUrl"><img class="logo" src="{{logoUrl}}" /></div><div><h3 class="chart-title">{{title}}<span class="sub" ng-if="subtitle">{{subtitle}}</span></h3></div><i class="icon-cloud-download" ng-click="exportChart()" title="Download chart"></i></div><div class="cl-chart cl-chart-bar" id="{{id}}_chart"></div><p ng-if="footer" class="footnote">{{footer}}​</p>',
            scope: {
                id: '@',
                chartDataKey: '@',
                filter: '=',
                subtitle: '=',
                title: '@',
                footnote: '@',
                sortBy: '@',
                sortOrder: '@',
				categoryAxisWidth: "@",
				maxValue: "=",
                exportDimensions: '@',
                sortIgnore: '@',
				logoUrl: '@',
                hideX: '@'
            },
            link: link
        };

        function link(scope, elm, attrs) {
            var chart,
                hiddenChart,
                hiddenID = scope.id + '_hidden',
                exportW = 800,
                exportH = 600,
                legendEnabled = false,
                axisColor = '#E5E5E5',
                valueAxisColor = scope.hideX ? 'transparent' : axisColor,
                categoryAxisColor = axisColor,
				categoryAxisWidth,
				sortBy,
				sortOrder,
				masterData,
				filter,
				filteredData,
				maxValue
			;

            if (angular.isDefined(scope.categoryAxisWidth)) {
				categoryAxisWidth = parseInt(scope.categoryAxisWidth);
            }
			
            if (angular.isDefined(scope.sortBy)) {
				sortBy = scope.sortBy;
            }

            if (angular.isDefined(scope.sortOrder)) {
				sortOrder = scope.sortOrder;
            }

            if (angular.isDefined(scope.maxValue)) {
				maxValue = scope.maxValue;
            }

            if (angular.isDefined(scope.exportDimensions)) {
				var dimensions = scope.exportDimensions.split('x');
				if (angular.isArray(dimensions) && dimensions.length == 2) {
					exportW = Number(dimensions[0]);
					exportH = Number(dimensions[1]);
				}
            } else if (elm.hasClass('tall')) {
            	exportH = 1000;
            } else if (elm.hasClass('xtall')) {
            	exportH = 1400;
            }

            elm.append('<div class="chart-hidden" id="' + hiddenID + '"></div>');
			
			function dataChanged(){
                if (masterData && masterData.data != undefined) {
					if (angular.isDefined(filter) && filter != null && filter != '') {
						filteredData = masterData.data[filter];
					} else {
						filteredData = masterData.data;
					}
					if (angular.isArray(filteredData)) {
						if (sortBy != undefined && sortBy != '') {
							var ignoredItem;
							if (angular.isDefined(scope.sortIgnore)) {
								for (var i = 0; i < filteredData.length; i++) {
									if (filteredData[i].Category === scope.sortIgnore) {
										ignoredItem = filteredData.splice(i, 1)[0];
										break;
									}
								}
							}
							if (sortOrder == 'desc') {
								filteredData.sort(function(a,b) {return (a[sortBy] > b[sortBy]) ? -1 : ((b[sortBy] > a[sortBy]) ? 1 : 0);} ); 
							} else {
								filteredData.sort(function(a,b) {return (a[sortBy] > b[sortBy]) ? 1 : ((b[sortBy] > a[sortBy]) ? -1 : 0);} ); 
							}
							if (ignoredItem) {
								filteredData.push(ignoredItem);
							}
						}
	                    if (chart == undefined) {
	                        render();
	                    }
	                    chart.dataProvider = filteredData;
	                    chart.validateData();
					}
					
					// footer
					var footer = DataFactory.getSamplesString(masterData, filter);
					scope.footer = footer;
                }
			}
			
			if (angular.isDefined(scope.chartDataKey)) {
				DataFactory.getJSON(scope.chartDataKey).then(function(response) {
					masterData = response;
					DataFactory.injectSampleInfo(masterData);
					dataChanged();
				});

	            if (angular.isDefined(scope.filter)) {
					filter = scope.filter;
		            scope.$watch('filter', function(newVal){
		            	filter = newVal;
						dataChanged();
		            });
	            } else if (angular.isDefined($rootScope.dataFilterSelected)){
	            	filter = $rootScope.dataFilterSelected.value;	
		            $rootScope.$watch('dataFilterSelected', function(newVal){
		            	filter = newVal.value;
						dataChanged();
		            });
	            }
			}

            function render() {

                var config = {
                    "type": "serial",
                    "categoryField": "Category",
                    "columnSpacing": 1,
                    "rotate": true,
                    "colors": SETTINGS.PALETTE,
                    "startDuration": 1,
                    "categoryAxis": {
                        "axisColor": categoryAxisColor,
                        "gridThickness": 0,
                        "color": SETTINGS.CHARTS.TEXT.COLOR
                    },
                    "trendLines": [],
                    "graphs": graphs(),
                    "valueAxes": [
                        {
                            "axisColor": valueAxisColor,
                            "gridThickness": 0,
                            "title": "",
                            "titleFontSize": 0,
                            "labelsEnabled": !scope.hideX,
                            "color": SETTINGS.CHARTS.TEXT.COLOR,
                            "minimum": 0,
                            "maximum": maxValue
                        }
                    ],
                    "legend": {
                        "enabled": legendEnabled,
                        "useGraphSettings": true,
                        "color": SETTINGS.CHARTS.TEXT.COLOR,
                        "fontSize": 12,
                        "equalWidths": false
                    },
                    "dataProvider": []
                };
				
				if (categoryAxisWidth != undefined && !isNaN(categoryAxisWidth)) {
					config["marginLeft"] = categoryAxisWidth;
					config["categoryAxis"]["ignoreAxisWidth"] = true;
					config["categoryAxis"]["autoWrap"] = true;
				}

                chart = AmCharts.makeChart(scope.id + "_chart", config, 100); // todo why is this delay needed? what hasn't loaded and how do we detect when it is loaded?

                function graphs() {

                    var graphs = [];

					if (masterData && angular.isDefined(masterData.meta) && angular.isArray(masterData.meta.series)) {
	                    // Get the graphs by looking at the first data point
	                    angular.forEach(masterData.meta.series, function (series) {
	                        graphs.push({
	                            "balloonText": "",//"[[title]] of [[category]]: <strong>[[value]]</strong>",
	                            "fillAlphas": 1,
	                            "title": series,
	                            "type": "column",
	                            "colorField": 'color',
								"lineColorField": 'color',
								"labelText": "[[" + series + "]]" + (maxValue == 100 ? "%" : ""),
                                "color": SETTINGS.CHARTS.TEXT.COLOR,
	                            "valueField": series
	                        });
	                    });
					}

                    legendEnabled = graphs.length > 1;

                    return graphs;
                }

                function exportChart() {

                    var exportConfig = {};

                    var hiddenDiv = angular.element(document.getElementById(hiddenID));
                    hiddenDiv.css({
                        width: exportW + 'px',
                        height: exportH + 'px'
                    });

                    // Copy visible chart config
                    angular.copy(config, exportConfig);

                    exportConfig.autoMargins = false;
                    exportConfig.marginLeft = categoryAxisWidth != undefined && !isNaN(categoryAxisWidth) ? Number(categoryAxisWidth) + 20 : 200;
                    exportConfig.marginRight = 80;
                    exportConfig.marginTop = 50;
                    exportConfig.marginBottom = 80;

                    // Update data
                    exportConfig.dataProvider = filteredData;

                    if (angular.isDefined(scope.title)) {
                        exportConfig.marginTop += 50;
                    }

                    if (angular.isDefined(scope.subtitle)) {
                        exportConfig.marginTop += 30;
                    }

                    if (angular.isDefined(scope.footer)) {
                        exportConfig.marginBottom += 50;
                    }

                    exportConfig.export = {
                        enabled: true,
                        libs: {
                            autoLoad: false
                        },
                        menu: [],
                        afterCapture: function () {
                            var instance = this;

                            // Logo
                            var imgEl = document.querySelector('#chart-header-img');

                            if (imgEl !== null) {
                                var logo = new fabric.Image(imgEl, {
                                    left: exportW - imgEl.width,
                                    top: 20
                                });
                                instance.setup.fabric.add(logo);
                            }

                            // Title
                            if (angular.isDefined(scope.title)) {
                                var title = new fabric.Text(scope.title, {
                                    left: 30,
                                    top: 50,
                                    fontFamily: SETTINGS.FONT_FAMILY,
                                    fontSize: 18
                                });
                                instance.setup.fabric.add(title);
                            }
							
                            if (angular.isDefined(scope.subtitle)) {
                                var subtitle = new fabric.Text(scope.subtitle, {
                                    left: 30,
                                    top: 80,
                                    fontFamily: SETTINGS.FONT_FAMILY,
                                    fontSize: 15
                                });
                                instance.setup.fabric.add(subtitle);
                            }

                            // footer
                            if (angular.isDefined(scope.footer)) {
                                var footer = new fabric.Text(scope.footer, {
                                    left: 30,
                                    top: exportH - 50,
                                    fontFamily: SETTINGS.FONT_FAMILY,
                                    fontSize: 10
                                });
                                instance.setup.fabric.add(footer);
                            }
                        }
                    };

                    hiddenChart = AmCharts.makeChart(hiddenID, exportConfig);

                    hiddenChart.export.capture({}, function () {
                        this.toPNG({}, function (data) {
                            this.download(data, this.defaults.formats.PNG.mimeType, scope.title);
                        });
                    });
                }

                scope.exportChart = exportChart;
            }
        }
    }
})();